module.exports = __webpack_public_path__ + "static/assets/77ec64aba9cc6e4f7857d1785576b809.ttf";